import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSummary: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconSummary"><Path fillRule="evenodd" clipRule="evenodd" d="M5 5V16H17V13.5L21.6667 17L17 20.5V18H3V5H5ZM8 6H18V8H8V6ZM8 11H14V13H8V11Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSummary;
